import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'pct_of_wrkrs_that_are_trade_union_members'

export const dataPointDefinition = {
  retracedId: 'pct_of_wrkrs_that_are_trade_union_members',
  name: 'PERCENTAGE of workers that are trade union members:',
  description: 'A trade union member is a worker who belongs to a trade union. ',
  meta: {
    unit: 'PERCENTAGE',
  },
  fieldTypeId: 'NUMBER_UOM',
  type: 'RELATIONAL',
  options: [
    {
      key: 'PERCENTAGE',
      name: 'Percentage',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
        minimum: 0,
        maximum: 100,
      },
      unit: {
        type: 'string',
        enum: ['PERCENTAGE'],
        minLength: 1,
      },
    },
    required: ['value', 'unit'],
  },
  externalIds: [
    {
      id: 'foa-cb-2--3',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 11770,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
